import { render, staticRenderFns } from "./DashboardBonificacao.vue?vue&type=template&id=3bd2a5c2&scoped=true"
import script from "./DashboardBonificacao.vue?vue&type=script&lang=js"
export * from "./DashboardBonificacao.vue?vue&type=script&lang=js"
import style0 from "./DashboardBonificacao.vue?vue&type=style&index=0&id=3bd2a5c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd2a5c2",
  null
  
)

export default component.exports